import type { FaireProductEntity } from "../../entity_types/product";

export const p_dq0bo72g: FaireProductEntity = {
  token: "p_dq0bo72g",
  type: "product",
  name: "You've Graduated Martini Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/3e9fc055f2420b21988b600acc0847c8af06074207ff22c1445b24affeb6f6fe.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b4694a7c30ebda240e6af130ab5a0797374bfb837ba98cd592c3f4e6963883c6.png",
    "https://cdn.faire.com/fastly/80238f44183a86fc3c93c48a848c2bb44cfa97a575cf34ce7a2eaa63036155f7.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:57.268Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
